module.exports = __webpack_public_path__ + "static/message-f507db448d76f2c6a369c7fe7f862b23.webp";